import React from 'react';

class ModalDialog extends React.Component {
  componentDidMount() {
    $("body").css("overflow", "hidden");
  }

  componentWillUnmount() {
    $("body").css("overflow", "auto");
  }

  handleBackgroundClick = e => {
    const { onClose } = this.props;
    if (e.target.id === 'component-modal-dialog') {
      e.preventDefault();
      return onClose(e);
    }
  };

  handleClose = e => {
    const { onClose } = this.props;
    e.preventDefault();
    return onClose(e);
  };

  render() {
    const { children } = this.props;
    return (
      <div className='component-modal-dialog'>
        <div className="dialog-close-container">
          <a href='#' onClick={this.handleClose}>Close <i className='fa fa-close' /></a>
        </div>
        <div className="dialog-body">
          {children}
        </div>
      </div>
    );
  }
}
export default ModalDialog;